import HoodieBig from 'assets/hoodie-big.png';
import HoodieBigHover from 'assets/hoodie-big-hover.png';
import KidsTee from 'assets/kids-big.png';
import KidsTeeHover from 'assets/kids-big-hover.png';
import MensTee from 'assets/mens-big.png';
import MensTeeHover from 'assets/mens-big-hover.png';
import WomenTee from 'assets/womens-big.png';
import WomenTeeHover from 'assets/womens-big-hover.png';
import PulloverHoodie from 'assets/pulloverhoodie-big.png';
import PulloverHoodieHover from 'assets/pulloverhoodie-big-hover.png';
import Sticker from 'assets/sticker-big.png';
import StickerHover from 'assets/sticker-big-hover.png';
import Sweater from 'assets/sweater-big.png';
import SweaterHover from 'assets/sweater-big-hover.png';
import { Trans } from '@lingui/react/macro';

export const typesConfig = {
  hoodie: {
    image: HoodieBig,
    imageHover: HoodieBigHover,
    label: <Trans>Hoodie</Trans>,
    smallLabel: <Trans>Hoodie</Trans>,
  },
  kids: {
    image: KidsTee,
    imageHover: KidsTeeHover,
    label: <Trans>Kids Tees</Trans>,
    smallLabel: <Trans>Kids</Trans>,
  },
  mens: {
    image: MensTee,
    imageHover: MensTeeHover,
    label: <Trans>Mens Tees</Trans>,
    smallLabel: <Trans>Mens</Trans>,
  },
  pulloverhoodie: {
    image: PulloverHoodie,
    imageHover: PulloverHoodieHover,
    label: <Trans>Pullover Hoodie</Trans>,
    smallLabel: <Trans>Pullover</Trans>,
  },
  sticker: {
    image: Sticker,
    imageHover: StickerHover,
    label: <Trans>Sticker</Trans>,
    smallLabel: <Trans>Sticker</Trans>,
  },
  sweater: {
    image: Sweater,
    imageHover: SweaterHover,
    label: <Trans>Sweater</Trans>,
    smallLabel: <Trans>Sweater</Trans>,
  },
  womens: {
    image: WomenTee,
    imageHover: WomenTeeHover,
    label: <Trans>Womens Tees</Trans>,
    smallLabel: <Trans>Womens</Trans>,
  },
};
